/* eslint-disable prefer-const */
import React from 'react';
import PropTypes from 'prop-types'
import { Alert as MuiAlert, AlertTitle } from '@mui/material';
import { useTranslation } from 'config/i18n';

const GraphAlert = ({ error, ...props }) => {
  const { t } = useTranslation(['common']);
  if (!error) {
    return null;
  }

  let severity = 'error';
  let title = null;
  let {
    graphQLErrors: [errorData = {}] = [],
    message = t('sorry.error'),
  } = error || {};


  if (errorData.extensions && errorData.extensions.level) {
    severity = errorData.extensions.level;
  }
  
  if (errorData.extensions && errorData.extensions.reason) {
    title = message;
    message = errorData.extensions.reason;
  }
  if (errorData.extensions && errorData.extensions.category === 'internal') {
    message = t('sorry.error')
  }
  
  return (
    <MuiAlert
      severity={severity}
      {...props}
    >
      { title && <AlertTitle> {title} </AlertTitle> }
      {message}
    </MuiAlert>
  );
};

GraphAlert.propTypes = {
    error: PropTypes.object
};


GraphAlert.defaultProps = {
  error: null
};





export default GraphAlert;
